import { SponsoredListingsCampaign } from 'src/WebApiController';

export const getPastFlightsForCampaign = (
  campaign: SponsoredListingsCampaign
) => {
  const currentFlight = campaign.activeFlight;
  const dateThreshold = currentFlight?.dateRange.start
    ? new Date(currentFlight.dateRange.start)
    : new Date();

  return campaign.flights
    ?.filter(
      (flight) =>
        flight.dateRange.end && new Date(flight.dateRange.end) <= dateThreshold
    )
    .toSorted((a, b) => {
      const ad = a.dateRange.end ? new Date(a.dateRange.end).getTime() : 0;
      const bd = b.dateRange.end ? new Date(b.dateRange.end).getTime() : 0;

      // Sort in descending order (most recent first)
      return bd - ad;
    });
};
